const upgradePersonal = {
  bannerTitle: '히트포 온라인 얼티밋',
  introduct:
    '인핸서, 리무버, AI 번역기, 스크린 레코더 등 35개 이상의 기능에 대한 프리미엄 혜택을 받으세요. 이 모든 것을 합리적인 가격으로 만나보세요.',
  Upgrade: '업그레이드',
  Tools: '툴킷',
  MyProjects: '내 파일',
  MyAccount: '내 계정',
  Subscription: '구독',
  LogOut: '로그아웃',
  PopularTools: '인기 툴킷',
  Enhance: '인핸서',
  Remove: '제거',
  Animate: '애니메이션',
  Extract: '추출',
  SaveThreeDays: '프로젝트는 3일간 저장되며, 처리 후 다운로드하세요.',
  All: '모든',
  Video: '동영상',
  Image: '이미지',
  Audio: '오디오',
  minutesAgo: '몇 분 전',
  hoursAgo: '몇 시간 전',
  daysAgo: '며칠 전',
  Modified: '수정됨',
  Order: '주문',
  EarliestToLatest: '최신에서 최신',
  LatestToEarliest: '최신순에서 초기순',
  NoProject: '프로젝트가 없습니다. 바로 시작',
  OnlineTools: '온라인 도구.',
  AIVideoEnhancer: 'AI 비디오 인핸서',
  Enhancer4K: '클릭 한 번으로 온라인에서 최대 4K까지 동영상을 AI로 향상하세요.',
  AIPhotoEnhancer: 'AI 사진 인핸서',
  AIEnhancerImage:
    '온라인에서 최대 8배까지 무손실로 이미지를 향상시키는 AI 사진 향상 도구',
  View: '보기',
  Download: '다운로드',
  MultipleSelect: '다중 선택',
  Delete: '삭제',
  SubscriptionHistory: '구독 내역',
  NoValidSubscription: '유효한 구독이 없습니다.',
  veContent: '클릭 한 번으로 온라인에서 최대 4K의 AI 비디오 향상',
  peContent: 'AI가 온라인에서 최대 8배까지 무손실 이미지 향상',
  rmvContent: '비디오에서 워터마크 제거',
  rmttContent: '눈 깜짝할 사이에 TikTok 비디오 워터마크 제거',
  dynamicContent: '온라인에서 사진에 애니메이션 적용',
  rmbgContent: '이미지에서 배경 제거',
  youMayNeed: '너는 필요할지도 모른다',
  new: '새로운',
  loginYourAccount: 'HitPaw 계정에 로그인',
  signUpYourAccount: 'HitPaw 계정에 가입',
  HitPawWatermark: 'Watermark Remover',
  HitPawTiktokWatermark: 'TikTok Watermark Remover',
  HitPawRemoveBg: 'Background Remover',
  dynamicTitle: 'HitPaw Online Animate Old Photos',
};
export default upgradePersonal;
